import { SITE_CONFIG } from "@/lib/seo";

export const websiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_CONFIG.name,
  url: SITE_CONFIG.url,
  description: SITE_CONFIG.description,
  inLanguage: "en-US",
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_CONFIG.url}/search?q={query}`,
    "query-input": "required name=query",
  },
};

export const organizationStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_CONFIG.name,
  url: SITE_CONFIG.url,
  logo: {
    "@type": "ImageObject",
    url: SITE_CONFIG.ogImage,
    width: 1200,
    height: 630,
  },
  description: SITE_CONFIG.description,
  foundingDate: "2024",
  sameAs: [
    // Can add social media links
    // "https://twitter.com/zests_ai",
    // "https://facebook.com/biblevod.com"
  ],
};

export const breadcrumbStructuredData = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: SITE_CONFIG.url,
    },
  ],
};
